/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from 'react'
import styles from './style.module.scss'
import PropTypes from 'prop-types'
import MyImage from '@shared/components/myImage'
import NoData from '@shared/components/noData'
import useWindowSize from '@shared/hooks/windowSize'
import { getImgURL } from '@shared-submodule/utils'
import CustomLink from '@shared/components/customLink'
import CommonNav from '@shared/components/commonNav'
import { useRouter } from 'next/router'
import queryGraphql from '@shared/components/queryGraphql'
import { GET_MAJOR_SERIES_DATA, GET_MAJOR_SERIES_DATA_FIXTURE } from '@graphql/champions-trophy/champions'
import usePolling from '@shared/hooks/usePolling'

function WPLMatches({ fixture = [], isMobile = false }) {
  const [width] = useWindowSize()
  const [isViewMore, setIsViewMore] = useState(false)
  const router = useRouter()
  const { query } = router
  const matchContainerRef = useRef(null)
  const [isUpcoming, setIsUpcoming] = useState(true)
  const [newFixtureData, setNewFixtureData] = useState(fixture)

  function scrollToMatch() {
    const currentTime = Date.now()

    if (fixture?.length > 0) {
      const nearestMatch = fixture.reduce((nearest, match) => {
        const matchTime = new Date(match.dStartDate).getTime()
        const currentNearest = new Date(nearest.dStartDate).getTime()

        return Math.abs(matchTime - currentTime) < Math.abs(currentNearest - currentTime) ? match : nearest
      })

      setTimeout(() => {
        const element = document.getElementById(nearestMatch.dStartDate)
        if (element) {
          matchContainerRef.current.scrollTo({
            top: element.offsetTop - 440,
            behavior: 'smooth'
          })
        }
      }, 300)
    }
  }

  useEffect(() => {
    if (width > 767) {
      scrollToMatch()
    }
  }, [width])

  useEffect(() => {
    if (query.tab === 'result') {
      setIsUpcoming(false)
    } else {
      setIsUpcoming(true)
    }
    if (width < 767) {
      const element = document.getElementById('matchContainer')
      element.scrollIntoView()
    }
  }, [query.tab])

  const upComingMatches = newFixtureData?.filter(d => d?.sStatusStr === 'scheduled' || d?.sStatusStr === 'live')

  const pastMatches = newFixtureData?.filter(d => d?.sStatusStr === 'completed')

  const data =
    width > 767 ? newFixtureData : isUpcoming ? isViewMore ? upComingMatches : upComingMatches?.slice(0, 5) : isViewMore ? pastMatches : pastMatches?.slice(0, 5)

  async function pollingCallback() {
    try {
      const allData = await queryGraphql(GET_MAJOR_SERIES_DATA_FIXTURE, {
        input: { iSeriesId: '6789e3d1365a27d0e1eb1025' }
      })
      return allData?.data?.getMajorSeriesData?.aFixtures
    } catch (error) {
      console.error('Error fetching data:', error)
    }
  }

  usePolling(async () => {
    const data = await pollingCallback()
    setNewFixtureData(data)
  })

  return (
    <div className={styles.matchContainer}>
      <div className="d-flex justify-content-between align-items-center">
        <h1 id="matchContainer" className="my-0 w-100 text-center">
          {'Women\'s Premier League'}
        </h1>
      </div>
      {width < 767 && (
        <CommonNav
          items={[
            { navItem: 'Upcoming', url: '/wpl-womens-indian-premier-league-2025?tab=upcoming', active: isUpcoming },
            { navItem: 'Result', url: '/wpl-womens-indian-premier-league-2025?tab=result', active: !isUpcoming }
          ]}
          isMatch
        />
      )}
      <div className={`${styles.matches}`} ref={matchContainerRef}>
        {data?.length === 0 && (
          <div className="mb-4">
            <NoData title="Quiet now, but the action is just around the corner. Keep your gear ready!" />
          </div>
        )}
        {data?.length > 0 &&
          data?.map((fixture, i) => {
            if (!isMobile && fixture?.oSeo?.sSlug) {
              return (
                <>
                  <CustomLink href={`/${fixture?.oSeo?.sSlug}`}>
                    <a>
                      <div id={fixture?.dStartDate} key={i} className={`${styles.match} d-flex justify-content-between align-items-center`}>
                        <div className="d-flex flex-row align-items-center justify-content-start text-center w-100 gap-2">
                          <MyImage src={getImgURL(fixture?.oTeamScoreA?.oTeam?.oImg?.sUrl)} height={45} width={45} />
                          <div className="d-flex flex-column text-start">
                            <h6 className="my-0 mt-1">{fixture?.oTeamScoreA?.oTeam?.sAbbr || ''}</h6>
                            {fixture?.oTeamScoreA?.sScores && (
                              <span className={styles.score}>
                                {fixture?.oTeamScoreA?.sScores || ''} {`(${fixture?.oTeamScoreA?.sOvers || ''})`}
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="d-flex flex-column text-center gap-1" style={{ width: '-webkit-fill-available' }}>
                          <span className={styles.status}>
                            {fixture?.sStatusStr === 'live' ? 'Live' : fixture?.sStatusStr === 'completed' ? 'Result' : fixture?.sStatusStr === 'Cancelled' ? 'Cancelled' : new Date(fixture?.dStartDate).toLocaleString('en-US', {
                              month: 'short',
                              day: 'numeric',
                              hour: '2-digit',
                              minute: '2-digit',
                              hour12: true
                            }) || ''}
                          </span>
                          <span className={styles.place}>
                            {fixture?.sSubtitle} {`, ${fixture?.oVenue?.sLocation}`}
                          </span>
                        </div>
                        <div className="d-flex flex-row justify-content-end align-items-center text-center w-100 gap-2">
                          <div className="d-flex flex-column text-end">
                            <h6 className="my-0 mt-1">{fixture?.oTeamScoreB?.oTeam?.sAbbr || ''} </h6>
                            {fixture?.oTeamScoreB?.sScores && (
                              <span className={styles.score}>
                                {fixture?.oTeamScoreB?.sScores || ''} {`(${fixture?.oTeamScoreB?.sOvers || ''})`}
                              </span>
                            )}
                          </div>
                          <MyImage src={getImgURL(fixture?.oTeamScoreB?.oTeam?.oImg?.sUrl)} height={45} width={45} />
                        </div>
                      </div>
                    </a>
                  </CustomLink>
                </>
              )
            } else {
              return (
                <>
                  <a>
                    <div id={fixture?.dStartDate} key={i} className={`${styles.match} d-flex justify-content-between align-items-center mt-4`}>
                      <div className="d-flex flex-row align-items-center justify-content-start text-center w-100 gap-2">
                        <MyImage src={getImgURL(fixture?.oTeamScoreA?.oTeam?.oImg?.sUrl)} height={45} width={45} />
                        <div className="d-flex flex-column text-start">
                          <h6 className="my-0 mt-1">{fixture?.oTeamScoreA?.oTeam?.sAbbr || ''}</h6>
                          {fixture?.oTeamScoreA?.sScores && (
                            <span className={styles.score}>
                              {fixture?.oTeamScoreA?.sScores || ''} {`(${fixture?.oTeamScoreA?.sOvers || ''})`}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="d-flex flex-column text-center gap-1" style={{ width: '-webkit-fill-available' }}>
                        <span className={styles.status}>
                          {fixture?.sStatusStr === 'live' ? 'Live' : new Date(fixture?.dStartDate).toLocaleString('en-US', {
                            month: 'short',
                            day: 'numeric',
                            hour: '2-digit',
                            minute: '2-digit',
                            hour12: true
                          }) || ''}
                        </span>
                        <span className={styles.place}>
                          {fixture?.sSubtitle} {`, ${fixture?.oVenue?.sLocation}`}
                        </span>
                      </div>
                      <div className="d-flex flex-row justify-content-end align-items-center text-center w-100 gap-2">
                        <div className="d-flex flex-column text-end">
                          <h6 className="my-0 mt-1">{fixture?.oTeamScoreB?.oTeam?.sAbbr || ''} </h6>
                          {fixture?.oTeamScoreB?.sScores && (
                            <span className={styles.score}>
                              {fixture?.oTeamScoreB?.sScores || ''} {`(${fixture?.oTeamScoreB?.sOvers || ''})`}
                            </span>
                          )}
                        </div>
                        <MyImage src={getImgURL(fixture?.oTeamScoreB?.oTeam?.oImg?.sUrl)} height={45} width={45} />
                      </div>
                    </div>
                  </a>
                </>
              )
            }
          })}
        {width < 767 && !isViewMore && data?.length > 0 && (
          <div className="w-100 d-flex mb-2 justify-content-center">
            <button className="theme-btn btn btn-primary" onClick={() => setIsViewMore(true)}>
              View More
            </button>
          </div>
        )}
      </div>
    </div>
  )
}

WPLMatches.propTypes = {
  fixture: PropTypes.array,
  isMobile: PropTypes.bool
}

export default WPLMatches
